import { ImportPage } from "@/features/import/pages/ImportPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/import/$templateType")({
	component: ImportRouteComponent,
});

function ImportRouteComponent() {
	const { templateType } = Route.useParams();
	return <ImportPage templateType={templateType} />;
}
